import React, { useState, useRef } from 'react';
import { Button } from './ui/button';
import { Shield, CreditCard, Clock, CheckCircle } from 'lucide-react';

const NewHeroSection = () => {
  const ctaLink = "https://calendly.com/davwaysolution/review";

  return (
    <section className="pt-24 pb-16 relative overflow-hidden" style={{ backgroundColor: '#0B1F3A' }}>
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-transparent to-black/20 pointer-events-none"></div>
      
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-white">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6">
              Stop Losing Thousands in{' '}
              <span style={{ color: '#D4AF37' }}>Hidden Card Fees</span>{' '}
              Every Month
            </h1>
            
            <p className="text-xl text-gray-300 mb-6 leading-relaxed">
              Recover hidden profit leaks and simplify payments — without changing how you operate.
            </p>
            
            {/* Trust badges */}
            <div className="flex flex-wrap items-center gap-4 text-sm text-gray-300 mb-4">
              <div className="flex items-center gap-2">
                <CheckCircle size={18} style={{ color: '#22C55E' }} />
                <span>PCI Compliant</span>
              </div>
              <div className="flex items-center gap-2">
                <CreditCard size={18} style={{ color: '#D4AF37' }} />
                <span>Visa, Mastercard, Amex & Discover</span>
              </div>
              <div className="flex items-center gap-2">
                <Clock size={18} style={{ color: '#F5C542' }} />
                <span>24/7 Support</span>
              </div>
            </div>

            {/* Social proof */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-4" style={{ backgroundColor: 'rgba(212, 175, 55, 0.15)', border: '1px solid rgba(212, 175, 55, 0.3)' }}>
              <span className="font-bold" style={{ color: '#D4AF37' }}>Over $2M in fees recovered</span>
              <span className="text-gray-400">for local businesses</span>
            </div>

            {/* Industry list */}
            <p className="text-sm text-gray-400 mb-8">
              Serving <span className="text-gray-300 font-medium">Auto Shop</span> · <span className="text-gray-300 font-medium">Restaurants</span> · <span className="text-gray-300 font-medium">Salons</span> · <span className="text-gray-300 font-medium">Motels</span> · <span className="text-gray-300 font-medium">Liquor Stores</span> and More
            </p>
            
            {/* CTA Button */}
            <a href="#calculator">
              <Button 
                className="text-white font-bold text-lg px-8 py-6 rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 hover:-translate-y-1"
                style={{ backgroundColor: '#22C55E' }}
              >
                See My Numbers
              </Button>
            </a>
          </div>
          
          {/* Right Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl relative">
              <img 
                src="https://customer-assets-v7afamib.emergentagent.net/job_de75de85-e4d7-4315-a967-b5c4bd23b3fd/artifacts/tqk4mzny_AdobeStock_605113287.webp"
                alt="Happy customer using payment system"
                className="w-full h-[400px] object-cover"
              />
            </div>
            {/* Floating card */}
            <div className="absolute bg-white rounded-lg shadow-xl px-3 py-2" style={{ zIndex: 10, maxWidth: '200px', top: '76%', left: '4%' }}>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#22C55E' }}>
                  <Shield className="text-white" size={16} />
                </div>
                <div>
                  <p className="font-bold text-gray-900 text-xs leading-tight">Up to 100% Recovery</p>
                  <p className="text-[10px] text-gray-500">Keep Every Dollar</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewHeroSection;
